import { BaseDto } from './base.dto';
import { OrderDto } from './order.dto';
import { SaleUnitCartDto } from './saleUnitCart.dto';
export class OrderPosSplitTableInfoDto extends BaseDto {
  identifier: number;
  order: OrderDto;
  saleUnitCart: SaleUnitCartDto;
}
